import bannerTranslation from "app/assets/files/key-value-translations/banner-message.json";
import { useKeyValueTranslation } from "app/hooks/useKeyValueTranslation";
import { replaceInlineLinks } from "app/utils/internationalization/TranslationPageRenderer";
import parse from "html-react-parser";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { showAntiScamBannerPaths } from "./TopBanner/constants";
import { AlertBanner, AntiScamHeader, AntiScamText } from "./styles";

export const AntiScamBanner = () => {
	const router = useRouter();
	const { getTranslatedString } = useKeyValueTranslation(bannerTranslation);
	const [showBanner, setShowBanner] = useState(false);

	const headerWithInlineLink = replaceInlineLinks(getTranslatedString("alertBannerHeader"), "alert-banner-key");
	const descWithInlineLink = replaceInlineLinks(getTranslatedString("alertBannerDescription"), "alert-banner-desc");

	useEffect(() => {
		try {
			const { pathname } = window.location;

			const showBanner = showAntiScamBannerPaths.includes(pathname);
			setShowBanner(showBanner);
		} catch (error) {}
	}, [router]);

	return showBanner ? (
		<div className={`segment mt32`}>
			<div className="segment__container">
				<AlertBanner showIcon type="warning">
					<div>
						<AntiScamHeader>{parse(headerWithInlineLink)}</AntiScamHeader>
						<AntiScamText weight={"regular"}>{parse(descWithInlineLink)}</AntiScamText>
					</div>
				</AlertBanner>
			</div>
		</div>
	) : (
		<></>
	);
};
